import { CountryCode } from '@data/shopify/admin/types'
import { type Locale } from './language'

export const defaultCountryCodes: Record<Locale, CountryCode> = {
  en: CountryCode.Gb,
  da: CountryCode.Dk,
  se: CountryCode.Se,
  de: CountryCode.De,
  nl: CountryCode.Nl,
}

type CountryNames = Record<CountryCode, string>

export const englishCountryNames: CountryNames = {
  AC: 'Ascension Island',
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AN: 'Netherlands Antilles',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Åland Islands',
  AZ: 'Azerbaijan',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'St. Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BQ: 'Caribbean Netherlands',
  BR: 'Brazil',
  BS: 'The Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Democratic Republic of the Congo',
  CF: 'Central African Republic',
  CG: 'Congo',
  CH: 'Switzerland',
  CI: `Côte d'Ivoire`,
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CX: 'Christmas Island',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  EH: 'Western Sahara',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FO: 'Faeroe Islands',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'The Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GS: 'South Georgia and the South Sandwich Islands',
  GT: 'Guatemala',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KM: 'Comoros',
  KN: 'Saint Kitts and Nevis',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'St. Martin',
  MG: 'Madagascar',
  MK: 'Former Yugoslav Republic of Macedonia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolia',
  MO: 'Macau',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PM: 'Saint Pierre and Miquelon',
  PN: 'Pitcairn Islands',
  PS: 'Palestinian Territories',
  PT: 'Portugal',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russia',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena',
  SI: 'Slovenia',
  SJ: 'Svalbard and Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  SS: 'South Sudan',
  ST: 'São Tomé and Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syria',
  SZ: 'Swaziland',
  TA: 'Tristan da Cunha',
  TC: 'Turks and Caicos Islands',
  TD: 'Chad',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'East Timor',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turkey',
  TT: 'Trinidad and Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Vatican City',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis and Futuna',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  ZZ: 'Unknown Region',
}

export const countryNames: Record<Locale, CountryNames> = {
  en: englishCountryNames,
  da: {
    AC: 'Ascension Island',
    AD: 'Andorra',
    AE: 'De Forenede Arabiske Emirater',
    AF: 'Afghanistan',
    AG: 'Antigua og Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AN: 'De Nederlandske Antiller',
    AO: 'Angola',
    AR: 'Argentina',
    AT: 'Østrig',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Ålandsøerne',
    AZ: 'Aserbajdsjan',
    BA: 'Bosnien-Hercegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'St. Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BQ: 'Caribbean Netherlands',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvetø',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocosøerne (Keelingøerne)',
    CD: 'Demokratiske Republik Congo',
    CF: 'Den Centralafrikanske Republik',
    CG: 'Congo',
    CH: 'Schweiz',
    CI: `Côte d'Ivoire`,
    CK: 'Cookøerne',
    CL: 'Chile',
    CM: 'Cameroun',
    CN: 'Kina',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Kap Verde',
    CW: 'Curaçao',
    CX: 'Juleøen',
    CY: 'Cypern',
    CZ: 'Tjekkiet',
    DE: 'Tyskland',
    DJ: 'Djibouti',
    DK: 'Danmark',
    DM: 'Dominica',
    DO: 'Den Dominikanske Republik',
    DZ: 'Algeriet',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypten',
    EH: 'Vestsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Etiopien',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandsøerne',
    FO: 'Færøerne (Føroyar)',
    FR: 'Frankrig',
    GA: 'Gabon',
    GB: 'Det Forenede Kongerige',
    GD: 'Grenada',
    GE: 'Georgien',
    GF: 'Fransk Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grønland (Kalaallit Nunaat)',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Ækvatorialguinea',
    GR: 'Grækenland',
    GS: 'South Georgia og De Sydlige Sandwichøer',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HM: 'Heard- og McDonaldøerne',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HU: 'Ungarn',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Det Britiske Territorium i Det Indiske Ocean',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kirgisistan',
    KH: 'Cambodja',
    KI: 'Kiribati',
    KM: 'Comorerne',
    KN: 'Saint Kitts og Nevis',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KY: 'Caymanøerne',
    KZ: 'Kasakhstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxembourg',
    LV: 'Letland',
    LY: 'Libyen',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'St. Martin',
    MG: 'Madagaskar',
    MK: 'Den Tidligere Jugoslaviske Republik Makedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongoliet',
    MO: 'Macao',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldiverne',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'Ny Kaledonien',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Nederlandene',
    NO: 'Norge',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Fransk Polynesien',
    PG: 'Papua Ny Guinea',
    PH: 'Filippinerne',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint Pierre og Miquelon',
    PN: 'Pitcairn',
    PS: 'Palæstinensiske territorier',
    PT: 'Portugal',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Rumænien',
    RS: 'Serbien',
    RU: 'Rusland',
    RW: 'Rwanda',
    SA: 'Saudi-Arabien',
    SB: 'Salomonøerne',
    SC: 'Seychellerne',
    SD: 'Sudan',
    SE: 'Sverige',
    SG: 'Singapore',
    SH: 'Saint Helena',
    SI: 'Slovenien',
    SJ: 'Svalbard og Jan Mayen',
    SK: 'Slovakiet',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Sydsudan',
    ST: 'São Tomé og Príncipe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Swaziland',
    TA: 'Tristan da Cunha',
    TC: 'Turks- og Caicosøerne',
    TD: 'Tchad',
    TF: 'De Franske Besiddelser i Det Sydlige Indiske Ocean',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadsjikistan',
    TK: 'Tokelau',
    TL: 'Østtimor',
    TM: 'Turkmenistan',
    TN: 'Tunesien',
    TO: 'Tonga',
    TR: 'Tyrkiet',
    TT: 'Trinidad og Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'De Mindre Amerikanske Oversøiske Øer',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VA: 'Vatikanstaten',
    VC: 'Saint Vincent og Grenadinerne',
    VE: 'Venezuela',
    VG: 'De Britiske Jomfruøer',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis og Futunaøerne',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'Sydafrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    ZZ: 'Ukendt region',
  },
  se: {
    AC: 'Ascension Island',
    AD: 'Andorra',
    AE: 'Förenade Arabemiraten',
    AF: 'Afghanistan',
    AG: 'Antigua och Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AN: 'Nederländska Antillerna',
    AO: 'Angola',
    AR: 'Argentina',
    AT: 'Österrike',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Åland',
    AZ: 'Azerbajdzjan',
    BA: 'Bosnien och Hercegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'S:t Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BQ: 'Karibiska Nederländerna',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvetön',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Demokratiska republiken Kongo',
    CF: 'Centralafrikanska republiken',
    CG: 'Kongo',
    CH: 'Schweiz',
    CI: 'Elfenbenskusten',
    CK: 'Cooköarna',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Kina',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Kuba',
    CV: 'Kap Verde',
    CW: 'Curaçao',
    CX: 'Julön',
    CY: 'Cypern',
    CZ: 'Tjeckien',
    DE: 'Tyskland',
    DJ: 'Djibouti',
    DK: 'Danmark',
    DM: 'Dominica',
    DO: 'Dominikanska republiken',
    DZ: 'Algeriet',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypten',
    EH: 'Västsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Etiopien',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandsöarna',
    FO: 'Färöarna',
    FR: 'Frankrike',
    GA: 'Gabon',
    GB: 'Storbritannien',
    GD: 'Grenada',
    GE: 'Georgien',
    GF: 'Franska Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Ekvatorialguinea',
    GR: 'Grekland',
    GS: 'South Georgia och South Sandwich Islands',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hong Kong',
    HM: 'Heard Island och McDonald Islands',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HU: 'Ungern',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Brittiska territoriet i Indiska oceanen',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordanien',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kirgizistan',
    KH: 'Kambodja',
    KI: 'Kiribati',
    KM: 'Komorerna',
    KN: 'Saint Kitts och Nevis',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KY: 'Caymanöarna',
    KZ: 'Kazakstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    LY: 'Libyen',
    MA: 'Marocko',
    MC: 'Monaco',
    MD: 'Moldavien',
    ME: 'Montenegro',
    MF: 'St Martin',
    MG: 'Madagaskar',
    MK: 'fd jugoslaviska republiken Makedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'mongoliet',
    MO: 'Macau',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldiverna',
    MW: 'Malawi',
    MX: 'Mexiko',
    MY: 'Malaysia',
    MZ: 'Moçambique',
    NA: 'Namibia',
    NC: 'Nya Kaledonien',
    NE: 'Niger',
    NF: 'Norfolkön',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Nederländerna',
    NO: 'Norge',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nya Zeeland',
    OM: 'oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Franska Polynesien',
    PG: 'Papua Nya Guinea',
    PH: 'Filippinerna',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint Pierre och Miquelon',
    PN: 'Pitcairnöarna',
    PS: 'palestinska territorierna',
    PT: 'Portugal',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Återförening',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Ryssland',
    RW: 'Rwanda',
    SA: 'saudi-arabien',
    SB: 'Salomonöarna',
    SC: 'Seychellerna',
    SD: 'Sudan',
    SE: 'Sverige',
    SG: 'Singapore',
    SH: 'Sankta Helena',
    SI: 'Slovenien',
    SJ: 'Svalbard och Jan Mayen',
    SK: 'Slovakien',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Sydsudan',
    ST: 'São Tomé och Príncipe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Swaziland',
    TA: 'Tristan da Cunha',
    TC: 'Turks- och Caicosöarna',
    TD: 'Tchad',
    TF: 'franska sydterritorierna',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadzjikistan',
    TK: 'Tokelau',
    TL: 'Östtimor',
    TM: 'Turkmenistan',
    TN: 'Tunisien',
    TO: 'Tonga',
    TR: 'Turkiet',
    TT: 'Trinidad och Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'Förenta staternas mindre avlägsna öar',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatikanstaten',
    VC: 'Saint Vincent och Grenadinerna',
    VE: 'Venezuela',
    VG: 'Brittiska Jungfruöarna',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis och Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Sydafrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    ZZ: 'Okänd region',
  },
  de: {
    AC: 'Ascension-Insel',
    AD: 'Andorra',
    AE: 'Vereinigte Arabische Emirate',
    AF: 'Afghanistan',
    AG: 'Antigua und Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AN: 'Niederländische Antillen',
    AO: 'Angola',
    AR: 'Argentinien',
    AT: 'Österreich',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Åland-Inseln',
    AZ: 'Aserbaidschan',
    BA: 'Bosnien und Herzegowina',
    BB: 'Barbados',
    BD: 'Bangladesch',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'St. Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivien',
    BQ: 'Karibische Niederlande',
    BR: 'Brasilien',
    BS: 'Die Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvetinsel',
    BW: 'Botswana',
    BY: 'Weißrussland',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Kokosinseln (Keelinginseln).',
    CD: 'Demokratische Republik Kongo',
    CF: 'Zentralafrikanische Republik',
    CG: 'Kongo',
    CH: 'Schweiz',
    CI: 'Elfenbeinküste',
    CK: 'Cookinseln',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'China',
    CO: 'Kolumbien',
    CR: 'Costa Rica',
    CU: 'Kuba',
    CV: 'Kap Verde',
    CW: 'Curaçao',
    CX: 'Weihnachtsinsel',
    CY: 'Zypern',
    CZ: 'Tschechische Republik',
    DE: 'Deutschland',
    DJ: 'Dschibuti',
    DK: 'Dänemark',
    DM: 'Dominica',
    DO: 'Dominikanische Republik',
    DZ: 'Algerien',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Ägypten',
    EH: 'Westsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Äthiopien',
    FI: 'Finnland',
    FJ: 'Fidschi',
    FK: 'Falklandinseln',
    FO: 'Färöer',
    FR: 'Frankreich',
    GA: 'Gabun',
    GB: 'Vereinigtes Königreich',
    GD: 'Grenada',
    GE: 'Georgien',
    GF: 'Französisch-Guayana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Äquatorialguinea',
    GR: 'Griechenland',
    GS: 'Südgeorgien und die Südlichen Sandwichinseln',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HM: 'Heard und McDonaldinseln',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HU: 'Ungarn',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Britischer Indischer Ozean Territorium',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaika',
    JO: 'Jordanien',
    JP: 'Japan',
    KE: 'Kenia',
    KG: 'Kirgisistan',
    KH: 'Kambodscha',
    KI: 'Kiribati',
    KM: 'Komoren',
    KN: 'St. Kitts und Nevis',
    KP: 'Nordkorea',
    KR: 'Südkorea',
    KW: 'Kuwait',
    KY: 'Kaimaninseln',
    KZ: 'Kasachstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'St. Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    LY: 'Libyen',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldawien',
    ME: 'Montenegro',
    MF: 'St. Martin',
    MG: 'Madagaskar',
    MK: 'Ehemalige jugoslawische Republik von Mazedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolei',
    MO: 'Macau',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediven',
    MW: 'Malawi',
    MX: 'Mexiko',
    MY: 'Malaysia',
    MZ: 'Mosambik',
    NA: 'Namibia',
    NC: 'Neukaledonien',
    NE: 'Niger',
    NF: 'Norfolk Insel',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Niederlande',
    NO: 'Norwegen',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Neuseeland',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Französisch-Polynesien',
    PG: 'Papua-Neuguinea',
    PH: 'Philippinen',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint-Pierre und Miquelon',
    PN: 'Pitcairninseln',
    PS: 'Palästinensische Gebiete',
    PT: 'Portugal',
    PY: 'Paraguay',
    QA: 'Katar',
    RE: 'Wiedervereinigung',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Russland',
    RW: 'Ruanda',
    SA: 'Saudi-Arabien',
    SB: 'Salomonen',
    SC: 'Seychellen',
    SD: 'Sudan',
    SE: 'Schweden',
    SG: 'Singapur',
    SH: 'St. Helena',
    SI: 'Slowenien',
    SJ: 'Spitzbergen und Jan Mayen',
    SK: 'Slowakei',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Südsudan',
    ST: 'São Tomé und Príncipe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Swasiland',
    TA: 'Tristan da Cunha',
    TC: 'Turks- und Caicosinseln',
    TD: 'Tschad',
    TF: 'Französischer Süden Gebiete',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadschikistan',
    TK: 'Tokelau',
    TL: 'Osttimor',
    TM: 'Turkmenistan',
    TN: 'Tunesien',
    TO: 'Tonga',
    TR: 'Truthahn',
    TT: 'Trinidad und Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tansania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'Kleinere vorgelagerte Inseln der Vereinigten Staaten',
    US: 'Vereinigte Staaten',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VA: 'Vatikanstadt',
    VC: 'St. Vincent und die Grenadinen',
    VE: 'Venezuela',
    VG: 'Britische Jungferninseln',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis und Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Südafrika',
    ZM: 'Sambia',
    ZW: 'Simbabwe',
    ZZ: 'Unbekannte Region',
  },
  nl: {
    AC: 'Ascension Island',
    AD: 'Andorra',
    AE: 'Verenigde Arabische Emiraten',
    AF: 'Afghanistan',
    AG: 'Antigua en Barbuda',
    AI: 'Anguilla',
    AL: 'Albanië',
    AM: 'Armenië',
    AN: 'Nederlandse Antillen',
    AO: 'Angola',
    AR: 'Argentinië',
    AT: 'Oostenrijk',
    AU: 'Australië',
    AW: 'Aruba',
    AX: 'Åland Islands',
    AZ: 'Azerbeidzjan',
    BA: 'Bosnië en Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'België',
    BF: 'Burkina Faso',
    BG: 'Bulgarije',
    BH: 'Bahrein',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'St. Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BQ: 'Caribisch gebied Nederland',
    BR: 'Brazilië',
    BS: `De Bahama's`,
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Wit-Rusland',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Democratische Republiek Congo',
    CF: 'Centraal-Afrikaanse Republiek',
    CG: 'Congo',
    CH: 'Zwitserland',
    CI: 'Ivoorkust',
    CK: 'Cookeilanden',
    CL: 'Chili',
    CM: 'Kameroen',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Kaap Verde',
    CW: 'Curaçao',
    CX: 'Christmaseiland',
    CY: 'Cyprus',
    CZ: 'Tsjechië',
    DE: 'Duitsland',
    DJ: 'Djibouti',
    DK: 'Denemarken',
    DM: 'Dominica',
    DO: 'Dominicaanse Republiek',
    DZ: 'Algerije',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypte',
    EH: 'Westelijke Sahara',
    ER: 'Eritrea',
    ES: 'Spanje',
    ET: 'Ethiopië',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandeilanden',
    FO: 'Faeröereilanden',
    FR: 'Frankrijk',
    GA: 'Gabon',
    GB: 'Verenigd Koninkrijk',
    GD: 'Grenada',
    GE: 'Georgië',
    GF: 'Frans-Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Groenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatoriaal-Guinea',
    GR: 'Griekenland',
    GS: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
    GT: 'Guatemala',
    GW: 'Guinee-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HM: 'Heard-eiland en McDonaldeilanden',
    HN: 'Honduras',
    HR: 'Kroatië',
    HT: 'Haïti',
    HU: 'Hongarije',
    ID: 'Indonesië',
    IE: 'Ierland',
    IL: 'Israël',
    IM: 'Man',
    IN: 'India',
    IO: 'Britse Indische Oceaan Territorium',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'IJsland',
    IT: 'Italië',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordanië',
    JP: 'Japan',
    KE: 'Kenia',
    KG: 'Kirgizië',
    KH: 'Cambodja',
    KI: 'Kiribati',
    KM: 'Comoren',
    KN: 'Saint Kitts en Nevis',
    KP: 'Noord-Korea',
    KR: 'Zuid-Korea',
    KW: 'Koeweit',
    KY: 'Kaaimaneilanden',
    KZ: 'Kazachstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litouwen',
    LU: 'Luxemburg',
    LV: 'Letland',
    LY: 'Libië',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldavië',
    ME: 'Montenegro',
    MF: 'St. Martin',
    MG: 'Madagaskar',
    MK: 'Voormalige Joegoslavische Republiek Macedonië',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolië',
    MO: 'Macau',
    MQ: 'Martinique',
    MR: 'Mauritanië',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediven',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Maleisië',
    MZ: 'Mozambique',
    NA: 'Namibië',
    NC: 'Nieuw-Caledonië',
    NE: 'Niger',
    NF: 'Norfolk Eiland',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Nederland',
    NO: 'Noorwegen',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nieuw-Zeeland',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Frans-Polynesië',
    PG: 'Papoea-Nieuw-Guinea',
    PH: 'Filipijnen',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint Pierre en Miquelon',
    PN: 'Pitcairneilanden',
    PS: 'Palestijnse Gebieden',
    PT: 'Portugal',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roemenië',
    RS: 'Servië',
    RU: 'Rusland',
    RW: 'Rwanda',
    SA: 'Saoedi-Arabië',
    SB: 'Salomonseilanden',
    SC: 'Seychellen',
    SD: 'Soedan',
    SE: 'Zweden',
    SG: 'Singapore',
    SH: 'Sint-Helena',
    SI: 'Slovenië',
    SJ: 'Spitsbergen en Jan Mayen',
    SK: 'Slowakije',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalië',
    SR: 'Suriname',
    SS: 'Zuid-Soedan',
    ST: 'São Tomé en Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrië',
    SZ: 'Swaziland',
    TA: 'Tristan da Cunha',
    TC: 'Turks- en Caicoseilanden',
    TD: 'Tsjaad',
    TF: 'Frans Zuidelijk Gebieden',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadzjikistan',
    TK: 'Tokelau',
    TL: 'Oost-Timor',
    TM: 'Turkmenistan',
    TN: 'Tunesië',
    TO: 'Tonga',
    TR: 'Turkije',
    TT: 'Trinidad en Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Oekraïne',
    UG: 'Oeganda',
    UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
    US: 'Verenigde Staten',
    UY: 'Uruguay',
    UZ: 'Oezbekistan',
    VA: 'Vaticaanstad',
    VC: 'Saint Vincent en de Grenadines',
    VE: 'Venezuela',
    VG: 'Britse Maagdeneilanden',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis en Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Zuid-Afrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    ZZ: 'Onbekende regio',
  },
}
